import React from "react";
import StatusChip from "../../components/system/StatusChip";

/**
 * Maps a tenant ``Company.status`` value to a StatusChip tone.
 * The five legal statuses (active|trial|suspended|cancelled|archived)
 * each get a deterministic tone so the status pill is consistent across
 * the operator surface.
 */
export const TENANT_STATUSES = [
  "active",
  "trial",
  "suspended",
  "cancelled",
  "archived",
];

const TONE_BY_STATUS = {
  active: "fresh",
  trial: "soon",
  suspended: "urgent",
  cancelled: "expired",
  archived: "neutral",
};

export default function TenantStatusPill({ status, "data-testid": testId }) {
  const safe = TENANT_STATUSES.includes(status) ? status : "neutral";
  const tone = TONE_BY_STATUS[safe] || "neutral";
  return (
    <StatusChip tone={tone} data-testid={testId}>
      {safe}
    </StatusChip>
  );
}
